export default __webpack_public_path__ + "static/media/approved-artwork-logo.3a657398.svg";